export default __webpack_public_path__ + "static/media/quick.959d598d.png";